import { LAYOUT_POPOUT_CONTAINER_CLASS } from '@genesislcap/foundation-layout';
import { html, ref, ViewTemplate } from '@genesislcap/web-core';
import type { MainApplication } from './main';
/**
 * @internal
 */
export const DynamicTemplate: ViewTemplate<MainApplication> = html<MainApplication>`
  <template>
    <rapid-design-system-provider ${ref('provider')} class="${LAYOUT_POPOUT_CONTAINER_CLASS}">
      <div class="dynamic-template">${(x) => x.selectTemplate()}</div>
    </rapid-design-system-provider>
  </template>
`;

/**
 * @internal
 */
export const LoadingTemplate: ViewTemplate<MainApplication> = html<MainApplication>`
  <fast-progress></fast-progress>
`;

export const MainRouterTemplate: ViewTemplate<MainApplication> = html<MainApplication>`
  <foundation-router
    @luminance-icon-clicked=${(x) => x.onLuminanceToggle()}
    :config=${(x) => x.combinedRouterConfig}
    :store=${(x) => (x.pageToRedirectTo === 'PBI' ? x.pbiStore : x.store)}
  ></foundation-router>
`;
